<template>
  <div id="top" class="i-container container">
    <div class="i-decoration-container row i-row">
      <TopMenu />
    </div>

    <div class="mainbody">
      <LeftMenu />

      <div id='main_content' role='main' class='i-css-menu-visability-visible'>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

// Components
import TopMenu from '@/components/layout/TopMenu.vue';
import LeftMenu from '@/components/layout/LeftMenu.vue';

export default defineComponent({
  components: {
    TopMenu,
    LeftMenu,
  },
});
</script>
